import React from "react";
import Header from "../components/header";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import Loader from "../components/Loader/Loader";
import { logoutRequest, logoutSuccess } from "../store/actions/logOutAction";
import { otpReset } from "../store/actions/otpAction";
import { auctionListRequest } from "../store/actions/allAuctionListAction";
import AuctionList from "../containers/nbfcAuctionList/auctionList";
import NoDataFound from "../components/notDataFound/noDataFound";
import { featureSettingsRequest } from "../store/actions/fetchFeatureSettingAction";
import { dateFormatYYYYMMDD } from "../utils/dateFormatDDMMYYYY";
import { auctionInvListReset } from "../store/actions/auctionInvAction";


export default function AuctionListPage(){

    const dispatch = useDispatch();
    const auctionListObj = useSelector((state) => state.allAuctionListReducer);
    const { loading, resAuctionList, error } = auctionListObj; 

    const featureSettingObj = useSelector((state) => state.fetchFeatureSettingReducer);
    const { loading: featureLoading, resFeature} = featureSettingObj; 

    useEffect(() => {
        dispatch(auctionListRequest());
    },[])

    useEffect(() => {
        dispatch(featureSettingsRequest({reqKey:"AUCTION_BANK_NAMES"}));
    },[])

    const logout = () => {
        dispatch(logoutRequest());
        dispatch(logoutSuccess());
        dispatch(otpReset());
        dispatch(auctionInvListReset())
      }

    const currentDate = dateFormatYYYYMMDD(new Date());
    //console.log("currentDate",currentDate);
    const liveAuctionsList = resAuctionList?.data?.filter(item => {
        const startDate = dateFormatYYYYMMDD(item.start_date);
        const endDate = dateFormatYYYYMMDD(item.end_date);

        if (startDate && endDate && currentDate) {
          if (currentDate >= startDate && currentDate <= endDate) {
            //console.log("currentDate",currentDate, startDate, endDate)
            return true;
          }
        }
        return false;
      });

      return (
        <>
            <Header>
                <Header.MaxWidth>
                <Header.Logo src="../assets/title/Tractor world Logo.svg" alt="Logo" />
                <p onClick={() => logout()} style={{display:'flex',alignItems:'center', cursor:'pointer', marginLeft:'auto'}}>Logout</p>
                </Header.MaxWidth>
            </Header>

            {(loading && featureLoading && resAuctionList?.data?.length === 0) ? <Loader /> : <AuctionList data={liveAuctionsList} resFeature={resFeature} />}
            {(!loading && (liveAuctionsList || '').length === 0) && 
            <NoDataFound msg={error ? "Something went wrong..." : (liveAuctionsList || '').length === 0 ? "No Live Auctions" : "No Data Found"} />
            } 
        </>
    )
}

